import { ComplaintsDropDownService } from './../../services/complaints_drop_down/complaints-drop-down.service';
import { VendorComplaintsService } from './../../services/vendor-complaints/vendor-complaints.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, PageEvent, MatDialog } from '@angular/material';
import { ViewChild } from '@angular/core';
import { VendorComplaintDocumentsComponent } from '../vendor-complaint-documents/vendor-complaint-documents.component';

@Component({
  selector: 'app-vendor-complaints',
  templateUrl: './vendor-complaints.component.html',
  styleUrls: ['./vendor-complaints.component.css']
})
export class VendorComplaintsComponent implements OnInit {
  dataSource: MatTableDataSource<IvendorComplaintsData>;
  displayedColumns = ['DebtorFirstName',
                      'DebtorLastName',
                      'VIN', 'Make', 'Year', 'Model', 'VendorLocation', 'ClientName',
                      'Type', 'DateOpened', 'Status', 'FileViewDownload'];
  message: string;
  sortedData;
  vendorComplaintsData: Array<IvendorComplaintsData> = [];
  vendorLocationList = [];
  vendorLocationComplaintList = [];
  addresssList = [];
  public MasterVendorId: any;
  errorMessage: string;
  pageSize = 10;
  pageEvent: PageEvent;
  errorEnable: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length: number;
  ispaginationFlag: boolean;
  displayVendorList: any[];
  MasterVendorName = '';

  constructor(public complaintservice: VendorComplaintsService,
              public complaintsDropDown: ComplaintsDropDownService,
              private changeDetectorRefs: ChangeDetectorRef,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.MasterVendorId = localStorage.getItem("AgentId");
    this.MasterVendorName = localStorage.getItem('AgentName');
    this.getComplaints(this.MasterVendorId);
  }

  getComplaints(Id) {
    this.complaintservice.getVendorComplaints(Id).subscribe(res => {
      if (res.Vendor_Complaints.length <= 0 || res.Vendor_Complaints === undefined) {
        this.vendorComplaintsData = [];
        this.message = "No Complaints found";
      } else {
        this.message = '';
        res.Vendor_Complaints.forEach((vendor,i) => {
          this.getVendorLocation(vendor['VendorLocationId'], this.MasterVendorId).then(result => {
            vendor['VendorLocation'] = result['fullAdd'];
            this.vendorComplaintsData.push(vendor)
            this.displayVendorList = this.vendorComplaintsData;
            this.dataSource = new MatTableDataSource(res.Vendor_Complaints);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.length = this.displayVendorList.length;
            if (this.length < 10) {
              this.ispaginationFlag = false;
            }
            else {
              this.ispaginationFlag = true;
            }
            if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
              this.paginator.pageIndex = this.paginator.pageIndex - 1;
            }
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            const paginatorIntl = new MatPaginatorIntl();
            paginatorIntl.itemsPerPageLabel = 'Items per page';
            paginatorIntl.nextPageLabel = 'Next page';
            paginatorIntl.previousPageLabel = 'Previous page';
            paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
              length = this.length;
              if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
              length = Math.max(length, 0);
              const startIndex = page * pageSize;
              // If the start index exceeds the list length, do not try and fix the end index to the end.
              const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
              const round = Math.ceil(length / 10)
              return `${(startIndex / 10) + 1}  of ${round}`;
            }
            this.dataSource.paginator._intl = paginatorIntl;
          });
        });
      }
    }, error => {
      this.errorMessage = 'Vendor Complaints Service' + ' ' + error;
      this.errorEnable = true;
    });
  }

  getVendorLocation(locationId, vendorId) {
    return new Promise((resolve, reject) => {
      this.vendorLocationList = [];
      this.complaintsDropDown.getLocationData(vendorId).subscribe(res => {
        if (res !== undefined && res !== '') {
          if (res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length > 0) {
            this.vendorLocationList = res.vendorLocationDetails;
            const locationData = this.vendorLocationList.find(x => x.LocationId === locationId);
            let address = [];
            locationData.Address1 !== null ? address.push(locationData.Address1) : '';
            locationData.Address2 !== null ? address.push(locationData.Address2) : '';
            locationData.State !== null ? address.push(locationData.State) : '';
            locationData.PostalCode !== null ? address.push(locationData.PostalCode) : '';
            let fullAddress = address.join();
            resolve({
              fullAdd: fullAddress
            })
          } else {
            this.errorMessage = "No Vendor Location data found ";
            this.errorEnable = true;
          }
        } else {
          this.errorMessage = "No Vendor Location data found ";
          this.errorEnable = true;
        }
      }, err => {
        this.errorMessage = "Users Vendor Location Service" + err;
        this.errorEnable = true;
      });
    })
  }

  viewAndDownloadDoc(complaintId) {
   
    const dialogRef = this.dialog.open(VendorComplaintDocumentsComponent, {
      disableClose: true,
      width: '55%',
      height: '75%',
      data: { ComplaintId : complaintId, MasterVendorId : this.MasterVendorId }
    });
  }
}

export interface IvendorComplaintsData {
  DebtorFirstName: string;
  DebtorLastName: string;
  VIN: string;
  Make: string;
  Year: number;
  Model: string;
  VendorLocation: string;
  ClientName: string;
  Type: string;
  DateOpened: Date;
  Status: string;
  FileViewDownload: string;
}



// WEBPACK FOOTER //
// ./src/app/components/vendor-complaints/vendor-complaints.component.ts